<template>
  <el-form ref="form" :model="formData" label-width="120px" v-loading="loading">
    <el-form-item label="旧密码">
      <el-input type="password" v-model="formData.oldPwd"></el-input>
    </el-form-item>
    <el-form-item label="新密码密码">
      <el-input type="password" v-model="formData.pwd"></el-input>
    </el-form-item>
    <el-form-item label="重复密码">
      <el-input type="password" v-model="formData.pwd2"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">修改密码</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import ajax from 'xelement/ajax'
import { api } from 'src/config'

export default {
  data() {
    return {
      loading: false,
      formData: {
        oldPwd: '',
        pwd: '',
        pwd2: ''
      }
    }
  },
  methods: {
    submit() {
      if(this.formData.oldPwd == '') {
        this.$message({
          showClose: true,
          message: '请输入旧密码',
          type: 'warning'
        });
        return false;
      }
      if(this.formData.pwd.length < 6 || this.formData.pwd2.length < 6){
        this.$message({
          showClose: true,
          message: '请输入大于6位的密码',
          type: 'warning'
        });
        return false;
      }
      if(this.formData.pwd != this.formData.pwd2){
        this.$message({
          showClose: true,
          message: '两次输入的密码不一致，请重新输入',
          type: 'warning'
        });
        return false;
      }
      this.loading = true;
      let _self = this;
      ajax(this, 'post', api.account.updatePwd, this.formData, (res) => {
        _self.$message({
          showClose: true,
          message: '操作成功',
          type: 'success'
        });
        _self.formData = {
          oldPwd: '',
          pwd: '',
          pwd2: ''
        }
      }, () => {
        _self.loading = false;
      })
    }
  },
  components: {
    
  }
}
</script>


// WEBPACK FOOTER //
// safe.vue?07709786